import { Controller } from "@hotwired/stimulus"

// Each select sits in a `.row` alongside a "View" link the server renders pointing at "#".
// The link carries no `disabled` attribute until this controller adds one, so the disabled
// state on load is the controller's job, not the server's.
export default class extends Controller {
  static get targets() { return ["select"]; }

  connect() {
    this.selectTargets.forEach(select => this.point(select));
  }

  sync(event) {
    this.point(event.currentTarget);
  }

  point(select) {
    const selected = select.selectedOptions[0];
    const url = selected ? selected.dataset.url : undefined;
    const link = select.closest(".row").querySelector("a.view");

    if (url !== undefined) {
      link.setAttribute("href", url);
      link.removeAttribute("disabled");
    } else {
      link.setAttribute("disabled", "disabled");
    }
  }
}
